export default "#map{width:100%;height:100%}";